export const getI18nLanguage = (language: string) => language.replace('-', '');
